import React, { useState } from 'react';
import { PT_HEALTH } from '../../../patients-list/config';
import type { PtDirectoryPatient, PtHealthStatus } from '../../../patients-list/types';
import { ptHueForInitials } from '../../../patients-list/utils';

export interface PatientDirectoryPhotoProps {
  patient: PtDirectoryPatient;
  health: PtHealthStatus;
  size?: number;
  showPhoto?: boolean;
}

export function PatientDirectoryPhoto({
  patient,
  health,
  size = 54,
  showPhoto = true,
}: PatientDirectoryPhotoProps) {
  const [failed, setFailed] = useState(false);
  const meta = PT_HEALTH[health];
  const hue = ptHueForInitials(patient.initials);
  const dot = size * 0.3;

  return (
    <div className="relative shrink-0" style={{ width: size, height: size }}>
      {patient.photo && showPhoto && !failed ? (
        <img
          src={patient.photo}
          alt={patient.first}
          onError={() => setFailed(true)}
          className="block rounded-full object-cover"
          style={{
            width: size,
            height: size,
            boxShadow: '0 0 0 1px var(--cream-2), 0 1px 3px rgba(20,20,30,0.10)',
          }}
        />
      ) : (
        <div
          className="flex items-center justify-center rounded-full font-semibold text-white"
          style={{
            width: size,
            height: size,
            background: hue,
            fontFamily: 'var(--font-display)',
            fontSize: size * 0.38,
            boxShadow: '0 0 0 1px var(--cream-2)',
          }}
        >
          {patient.initials}
        </div>
      )}
      <span
        title={meta.label}
        className="absolute rounded-full"
        style={{
          right: -1,
          bottom: -1,
          width: dot,
          height: dot,
          background: meta.color,
          border: '2.5px solid var(--cream-1)',
        }}
      />
    </div>
  );
}
